/**
 * 🔒 The Cover Required page (decision 9680; T3368): a file the cover refuses, opened in a browser, lands here rather
 * than on the API's refusal, naming the account and the signed-in person beside piece 9's sentence. Its Request Cover
 * asks HR, by a Manual to-do, to upload the person's employment agreement, and sends nothing by mail.
 */

/** The web page a refused file opens on, the router's pattern and one file's address. */
export const COVER_ROUTE = '/files/:fileId/cover';
export const coverRoute = (fileId: string): string => `/files/${encodeURIComponent(fileId)}/cover`;

/** The API's read of the page, and the request its Request Cover writes. */
export const fileCoverPath = (fileId: string): string => `/files/${encodeURIComponent(fileId)}/cover`;
export const fileCoverRequestsPath = (fileId: string): string => `/files/${encodeURIComponent(fileId)}/cover-requests`;

/** What the page reads: whether the cover refuses this viewer the file, and the account, the person and the sentence it names. */
export interface CoverPageAnswer {
  refused: boolean;
  account: string | null;
  person: string;
  file: string;
  sentence: string | null;
}

/** What Request Cover answers: how many HR holders were asked, a holder whose same to-do is still open counted as asked. */
export interface CoverRequestAnswer {
  asked: number;
  person: string;
}

/** 🔒 The to-do Request Cover writes to each HR holder, naming the person to cover. */
export function coverRequestTitle(person: string): string {
  return `Upload the employment agreement for ${person}`;
}

/** 🔒 The to-do's line beneath its title, naming the account that asked and the file the person could not open. */
export function coverRequestDescription(facts: { person: string; account: string | null; file: string }): string {
  return `${facts.person} could not open ${facts.file}${facts.account ? ` because ${facts.account} requires an NDA` : ''}. Upload their signed Employment Agreement under Employment Documents on their Person page, answering the confidentiality question Yes.`;
}

/**
 * Whether a stream request is a page the browser is opening, which a refusal answers with the Cover Required page,
 * rather than a read a screen makes, which keeps the API's answer.
 */
export function isPageNavigation(headers: Readonly<Record<string, unknown>>): boolean {
  const mode = headers['sec-fetch-mode'];
  if (typeof mode === 'string') return mode === 'navigate';
  const accept = headers.accept;
  return typeof accept === 'string' && accept.includes('text/html');
}
